// Carrusel de fotos de la ficha: solo sincroniza los puntos con el arrastre.
//
// El arrastre lo hace el navegador con scroll nativo y scroll-snap. Este script
// NO mueve el carrusel por su cuenta: si no llega a cargar, se sigue pudiendo
// arrastrar con el dedo, la rueda y el teclado. Lo único que se pierde son los
// puntos y las flechas.

document.querySelectorAll('[data-carrusel]').forEach((carrusel) => {
  const pista = carrusel.querySelector('[data-carrusel-pista]');
  const puntos = [...carrusel.querySelectorAll('[data-ir]')];
  if (!pista || puntos.length === 0) return;

  const marcar = (i) => {
    puntos.forEach((p, n) => {
      p.classList.toggle('carrusel__punto--activo', n === i);
      // aria-current y no solo la clase: el color por si solo no le dice nada
      // a quien navega con lector de pantalla.
      if (n === i) p.setAttribute('aria-current', 'true');
      else p.removeAttribute('aria-current');
    });
  };

  // Qué foto se está viendo = cuánto se ha desplazado entre el ancho de una.
  // Se calcula del propio DOM y no de una constante: si cambia el tamaño de la
  // caja en CSS, esto sigue cuadrando sin tocar nada.
  const cual = () => {
    const paso = pista.firstElementChild?.getBoundingClientRect().width || 1;
    return Math.round(pista.scrollLeft / paso);
  };

  let pendiente = false;
  pista.addEventListener('scroll', () => {
    // El evento de scroll se dispara decenas de veces por gesto. Sin esto se
    // recalcula el layout en cada una y el arrastre va a tirones en móvil.
    if (pendiente) return;
    pendiente = true;
    requestAnimationFrame(() => { marcar(cual()); pendiente = false; });
  }, { passive: true });

  puntos.forEach((p, i) => {
    p.addEventListener('click', () => {
      const paso = pista.firstElementChild?.getBoundingClientRect().width || 0;
      pista.scrollTo({ left: paso * i, behavior: 'smooth' });
      marcar(i);
    });
  });

  // Flechas del teclado sobre la pista, que es la que tiene el foco.
  pista.addEventListener('keydown', (ev) => {
    if (ev.key !== 'ArrowRight' && ev.key !== 'ArrowLeft') return;
    ev.preventDefault();
    const paso = pista.firstElementChild?.getBoundingClientRect().width || 0;
    const destino = cual() + (ev.key === 'ArrowRight' ? 1 : -1);
    const i = Math.max(0, Math.min(puntos.length - 1, destino));
    pista.scrollTo({ left: paso * i, behavior: 'smooth' });
    marcar(i);
  });
});
